import * as z from "zod";
import { assertIdpSyncNotActive } from "../rbac/validation";
import { deleteUserGroupCascade } from "../rbac/userGroups";
import { monitoringAnalytics } from "./monitoringAnalytics";
import { mutator } from "./mutator";

export const deleteUserGroup = mutator({
  stripKeys: { analytics: Object.keys(monitoringAnalytics.shape) },
  schema: z.object({
    analytics: monitoringAnalytics.optional(),
    userGroupId: z.string(),
  }),
  resolve: {
    userGroup: { kind: "userGroup", from: "userGroupId" },
  },
  permissions: [
    {
      permission: "user_group:write",
      scopeId: ({ args }) => args.userGroup.id,
    },
  ],
  fn: async ({ tx, ctx, args: { userGroup } }) => {
    await assertIdpSyncNotActive(tx, ctx.tenantId, "groupLifecycle");
    await deleteUserGroupCascade(tx, userGroup.id, ctx.tenantId);
  },
});
